import { useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material'

import { useModal } from '../../context/modal-context'

export const ValidateCodeDialog = () => {
  const { openOtp, hideOtpModal, confirmOtpCode } = useModal()
  const [openCancelDialog, setOpenCancelDialog] = useState(false)
  const [code, setCode] = useState('')

  const handleCancelConfirm = () => {
    setOpenCancelDialog(false)
  }
  const handleOpenConfirm = () => {
    setOpenCancelDialog(true)
  }
  return (
    <>
      <Dialog open={openOtp} onClose={handleOpenConfirm}>
        <DialogTitle>Validar código</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>Enviamos un código de 6 dígitos a tu correo.</Typography>
          <TextField
            label="Código"
            variant="outlined"
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 6,
              style: {
                letterSpacing: '10px',
                textAlign: 'center',
                fontSize: '24px',
              },
            }}
            value={code}
            onChange={e => {
              const val = e.target.value.replace(/\D/g, '')
              if (val.length <= 6) setCode(val)
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOpenConfirm}>Cancelar</Button>
          <Button
            onClick={() => {
              confirmOtpCode(code)
              setCode('')
            }}
            variant="contained"
          >
            Verificar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Cancel Dialog */}
      <Dialog open={openCancelDialog} onClose={handleCancelConfirm}>
        <DialogTitle>¿Estás seguro?</DialogTitle>
        <DialogContent>
          <Typography>¿Quieres cancelar el proceso de validación del código?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirm}>No</Button>
          <Button
            onClick={() => {
              hideOtpModal()
              handleCancelConfirm()
            }}
            variant="contained"
            color="error"
          >
            Sí, cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
